'use strict';

exports.__esModule = true;
exports.default = traverse;

var _react = require('react');

var _Element = require('../Element');

var _Element2 = _interopRequireDefault(_Element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function traverse(child, processCallback, replaceCallback) {
  if (Array.isArray(child)) {
    return _react.Children.map(child, function (children) {
      return traverse(children, processCallback, replaceCallback);
    });
  }

  if (!child || typeof child === 'string') {
    return child;
  }

  if (child === _Element2.default || _Element2.default.isPrototypeOf(child.type)) {
    return child;
  }

  if (replaceCallback) {
    var replacedChild = replaceCallback(child);
    if (replacedChild) {
      return traverse(replacedChild, processCallback, replaceCallback);
    }
  }

  if (processCallback) {
    var processedChild = processCallback(child);
    if (processedChild) {
      return processedChild;
    }
  }

  // support for preact
  var children = child.props && child.props.children || child.children;
  if (children) {
    var traversedChildren = traverse(children, processCallback, replaceCallback);
    // speed up
    if (traversedChildren === children) {
      return child;
    }

    return (0, _react.cloneElement)(child, {}, traversedChildren);
  }

  return child;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/utils/traverse.js
 ** module id = 1293
 ** module chunks = 0
 **/